
export class ServiceMetaData {
    fromRecord?: number;
    searchId?: number;
    toRecord?: number;
    totalRecords?: number;
}